import type { LogUsage } from '@bentley/pw-config';
import { useLogUsage } from '@bentley/pw-config';
import { useConfigContext, useOidcContext } from '../../context';

export function useUsageLogging(): LogUsage {
  const { config } = useConfigContext();
  const { getOidcToken } = useOidcContext();

  const buddiRegionCode = config.BUDDIRegionCode;
  const contextId = parseContextId();

  const logUsage = useLogUsage({
    buddiRegionCode,
    contextId,
    getOidcToken
  });
  return logUsage;
}

export function parseContextId(): string | undefined {
  const pathParts = window.location.pathname.split('/');
  const contextIdx = pathParts.indexOf('context');

  if (contextIdx < 0 || contextIdx >= pathParts.length - 1) {
    return undefined;
  }

  return pathParts[contextIdx + 1];
}
